module.exports = __webpack_public_path__ + "img/home.02932c5f.png";